import React, { useEffect,useRef,  useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {fetchGlobalData} from '../Actions/Action_GetGlobalStats';
import Moment from 'react-moment';
import moment from 'moment';
  
function GlobalStats(){
const dispatch = useDispatch();
useEffect(()=>{
    dispatch(fetchGlobalData());
     return()=>{
         console.log("Terminated");
     }
 },[])

const GlobalData = useSelector(state => state.GlobalDataRed.Global_Stat );
const[selected_country_name, set_selected_country_name] = useState(null);
const[CountryFilterdData, set_CountryFilterdData] = useState([]);
function FilterCountryData(countryName){
    set_selected_country_name(countryName);
    set_CountryFilterdData(GlobalData.filter(item => item.Country.toLowerCase() === countryName.toLowerCase()));
}

const StatsDiv = (
    CountryFilterdData.length > 0  ?
                <div class="resourcediv testStatsDiv"> 

                                            <div class="row infocards">    
                                                                    <div class="col-md-4">
                                                                            <center>
                                                                                <h2 class="totalCaseCardHead"> TOTAL</h2>
                                                                            </center>
                                                                            <center>
                                                                                    <p id="total" class="totalCaseContent" style={{color:"#5454b8"}}>
                                                                                        {parseInt(CountryFilterdData[0].TotalConfirmed).toLocaleString()}  </p>
                                                                            </center>
                                                                    
                                                                        
                                                                    </div>



                                                                    <div class="col-md-4">
                                                                        <center>
                                                                            <h2 class="recCardHead">RECOVERED</h2>
                                                                        </center>
                                                                        <center> 
                                                                                <p id="recovered" class="recContent" >
                                                                                {parseInt(CountryFilterdData[0].TotalRecovered).toLocaleString()} 
                                                                                </p>
                                                                        </center>
                                                                    
                                                                        
                                                                            
                                                                    </div>

                                                                        <div class="col-md-4">
                                                                            <center>  
                                                                                <h2 class="deathCardHead" style={{background:"#d3d3d333"}}>DEATHS</h2>
                                                                            </center>
                                                                            <center>
                                                                                <p id="death" class="deathContent" >
                                                                                {parseInt(CountryFilterdData[0].TotalDeaths).toLocaleString()} 

                                                                                    </p>
                                                                            </center>
                                                                        
                                                                        
                                                                        
                                                                    </div>

                                                                
                                                    </div> 
                                                            
                                                    <p class="LastUpdatedLabel" style={{color:'grey', marginLeft:'60%'}}>*Last updated on { <Moment format="LLLL">
                                                                                                    {moment(CountryFilterdData[0].Date, 'YYYY-MM-DD HH:mm').format()}
                                                                                            </Moment> }.                                            
                                                    </p>
                                                


                
                    
                                        
                        
                                </div>
                        :
                         ""
)

    return (
        <div>
                    <div className="search-appointments row justify-content-center my-4">
                        <div className="col-md-6">  
                                <div className="input-group-append">
                                        <button
                                            type="button"
                                            className="btn dropdown-toggle stateToogle"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            style={{color:'gray',marginTop:'10px', backgroundColor:'rgba(211, 211, 211, 0.17)',borderColor:'transparent'}}
                                        >
                                            {selected_country_name != null ? selected_country_name
                                            :
                                            <text>Select the Country</text>      
                                            }
                                        <span className="caret" />

                                        </button>
                                        <div className="sort-menu dropdown-menu dropdown-menu-right stateList">
                                        {GlobalData != undefined ?
                                        
                                        GlobalData.map(item =>
                                                    <button 
                                                        class="sort-by dropdown-item" 
                                                        value={item.Country} href="#"
                                                        onClick={e => FilterCountryData(e.target.value) }    

                                                    >
                                                        {item.Country}
                                                    </button>
                                        
                                                )
                                        :
                                        <p>Loading.....</p>
                                         }
                                                {/* {this.props.stateNames.map(item => (
                                                
                                                    c<button class="sort-by dropdown-item" value={item} href="#" onClick={ e => this.showResources(e.target.value)}> {item}</button>
                                                ))} */}
                                        </div>
                                </div>
                        </div>
                    </div>
                                        {StatsDiv}
       </div> 
    )
}
export default GlobalStats